<div class="bg-gray-1000 rounded-s flex flex-col gap-3">
  <div class="text-center">
    <span class="text-gray-500 b2"> Confidence Interval </span>
    <hr class="border-gray-900 mt-2 mb-0" />
  </div>

  <div class="flex flex-col gap-2 items-center">
    <div class="flex b2 text-white justify-center w-full">
      <span>{{ lowerBound }}</span>
      <span class="mx-[5.5rem]">{{ metricValue }}</span>
      <span>{{ upperBound }}</span>
    </div>

    <div class="h-[4.375rem] w-full">
      <img
        src="assets/images/creative/bell-curve.svg"
        alt="Confidence Interval Bell Curve"
        class="w-full h-full object-contain" />
    </div>
  </div>

  <div class="flex flex-col">
    <div class="flex flex-col items-center justify-center text-white b2">
      <span>
        This result is likely between {{ lowerBound }} and
        {{ upperBound }},</span
      >
      <span>with {{ metricValue }} being the most probable.</span>
      <hr class="border-gray-900 w-full my-2" />
    </div>

    <div class="flex flex-col items-center justify-center">
      <span class="b2 text-gray-500">
        {{ statisticalSignificance }}
      </span>
      <span class="c2 text-gray-500"> Statistical significance </span>
    </div>
  </div>
</div>
